import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';
// import navbarLogo from '../assets/images/navbar_logo.png';
// import navbarText from '../assets/images/navbar_text.png';
import { gsap } from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

const Navbar = () => {
  const scrollToTop = () => {
    // Use GSAP's ScrollSmoother to scroll to top
    const smoother = ScrollSmoother.get();
    if (smoother) {
      smoother.scrollTo(0, true);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" onClick={scrollToTop} style={{ textDecoration: 'none' }}>
          {/**
           * Removed per request: top navbar logo image (className: "navbar-logo").
           */}
          {/*
          <img 
            src={navbarLogo} 
            alt="Navbar Logo" 
            className="navbar-logo"
            style={{ cursor: 'pointer' }}
          />
          */}
          <img 
            src={`${process.env.PUBLIC_URL}/images/playerstat_official.svg`} 
            alt="Navbar Text" 
            className="navbar-text"
            style={{ cursor: 'pointer' }}
          />
        </Link>
      </div>
      <div className="navbar-right">
        <Link to="/contact" style={{ textDecoration: 'none' }}>
          <button className="contact-button">
            Contact Us
          </button>
        </Link>
      </div>
    </nav>
  );
};

export default Navbar; 